import { PageBlueprint } from '@backstage/frontend-plugin-api';
import kubernetesAlpha from '@backstage/plugin-kubernetes/alpha';
import CloudIcon from '@material-ui/icons/Cloud';

// title, icon, AND routeRef are all required for the new frontend system
// to auto-infer a nav item from a PageBlueprint. Without them the override
// page renders at /kubernetes but never appears in the sidebar.
// We pull the routeRef from the upstream plugin's `routes.kubernetes`
// because rootCatalogKubernetesRouteRef itself is not re-exported from the
// package's public type defs in v0.12.18.
export const kubernetesPage = PageBlueprint.make({
  params: {
    path: '/kubernetes',
    title: 'Kubernetes',
    icon: <CloudIcon />,
    routeRef: kubernetesAlpha.routes.kubernetes,
    loader: () =>
      import('./ClusterOverviewPage').then(m => <m.ClusterOverviewPage />),
  },
});
